// import axios from 'axios';
import Cookies from 'js-cookie/src/js.cookie';
import $ from 'jquery';

/**
 * Flyout that appears from the first visitor
 */
const initNewsletterFlyout = (): void => {
  if (!Cookies.get('seen_newsletter_popup')) {

    const flyoutElement = document.querySelector('[data-newsletter-popup]');
    if (flyoutElement) {
      if (window['theme'] && window['theme']['delay']) {
        const delay = Number(window['theme']['delay']);
        if (delay) {
          setTimeout(() => {
            flyoutElement.classList.add('visible');
            Cookies.set('seen_newsletter_popup', true);
          }, delay * 1000)
        } else {
          flyoutElement.classList.add('visible');
          Cookies.set('seen_newsletter_popup', true);
        }
      } else {
        flyoutElement.classList.add('visible');
        Cookies.set('seen_newsletter_popup', true);
      }
    }
  }
}

/**
 * Footer popup
 */
const initNewsletterPopup = (): void => {
  const popupForm = document.querySelector('[data-newsletter-popup-container]');
  const popupTrigger = document.querySelector('[data-newsletter-popup-trigger]');
  if (!popupForm || !popupTrigger) return;

  popupTrigger.addEventListener('click', (event) => {
    event.preventDefault();
    const input: HTMLInputElement = popupForm.querySelector('input[name="EMAIL"]');
    const initialInput: HTMLInputElement = document.querySelector('[data-newsletter-popup-initial-input]');
    const body = document.querySelector('body');

    if (input && initialInput) {
      const val = initialInput.value;
      input.value = val;
    }

    body.setAttribute('data-modal-triggered', 'modal-newsletter')
  });
}

const subscribeToNewsletter = (form: HTMLFormElement) => {
  const $form = $(form);
  // Ensuring we use the /post-json endpoint instead of /post
  let url = form.getAttribute('action').replace('/subscribe/post?', '/subscribe/post-json?');
  url += '&c=?';

  // I know, this is crap, but mailchimp didn't seem to work very well with the fetch or axios plugins so I'm sticking 
  // with jQuery. 
  $.ajax({
    type: $form.attr('method'),
    url: url,
    data: $form.serialize(),
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function () { alert('Could not connect to the registration server. Please try again later.'); },
    success: function (data) {
      if (data.result !== 'success') {
        const response = document.querySelector('[data-flyout-response]');
        response.innerHTML = data.msg;
        response.classList.remove('hide');
      } else {
        const form = document.querySelector('[data-flyout-form]');
        form.classList.add('hide');

        const response = document.querySelector('[data-flyout-response]');
        response.innerHTML = `<p>${data.msg}</p>`;
        response.classList.remove('hide');
      }
    }
  });
}

const initMailchimpAjaxSubmit = (): void => {
  const form: HTMLFormElement = document.querySelector('[data-mc-form]');

  if (form) {
    form.querySelector('input[type="submit"]').addEventListener('click', (event) => {
      event.preventDefault();
      subscribeToNewsletter(form);
    })
  }

}

export { initNewsletterFlyout, initMailchimpAjaxSubmit, initNewsletterPopup };